exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification-message{\n    width:300px;\n    white-space: initial;\n    cursor: pointer;\n}\n\n.notification .notification-footer{\n   text-align: center;\n}\n\n.notification .notification-footer a{\n    text-decoration: none;\n }\n\n.notification .notification-content {\n    overflow-y: auto;\n    max-height: 350px;\n}\n\n.notifications-wrapper {\n    max-height: 18.2rem;\n    overflow-y: auto;\n}\n", ""]);

// exports
